import React from 'react';
import c from '../w.js';

const IconKrw = React.memo(
  c(
    /* @__PURE__ */ React.createElement("path", { d: "M20.4655 9.81472H19.4875L20.5358 5.90918H18.3114L17.2951 9.81472H14.1694L13.1339 5.90918H10.8583L9.82278 9.81472H6.69707L5.68073 5.90918H3.4563L4.50459 9.81472H3.52661V11.221H4.88172L5.2205 12.493H3.52661V13.8992H5.59763L6.96553 19.0001H9.38812L10.8135 13.8992H13.185L14.604 19.0001H17.0266L18.3945 13.8992H20.4655V12.493H18.7716L19.1104 11.221H20.4655V9.81472ZM14.8853 12.493L14.5465 11.221H16.9307L16.6047 12.493H14.8853ZM7.06141 11.221H9.44565L9.10687 12.493H7.3938L7.06141 11.221ZM11.2035 12.493L11.5614 11.221H12.4435L12.7951 12.493H11.2035ZM16.234 13.8992L15.8121 15.5356H15.6907L15.256 13.8992H16.234ZM7.75815 13.8992H8.73613L8.30147 15.5292H8.18002L7.75815 13.8992Z" })
  )
);

export { IconKrw };
